import {
    Box,
    Card,
    CardContent,
    Typography
} from '@material-ui/core'
import styled from "styled-components/macro";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import { createA11y, deleteA11y, fetchA11yes, updateA11y } from "../../../../redux/actions/a11yesActions";
import { GradientText, GradientWrapper } from './SwitchControl';
import { AppDispatchType } from '../../../../redux/store';
import { useTranslation } from "react-i18next";
import {checkDependsCondition} from "../../../../utils/functions";

const QTitle = styled(Box)`
    ${(props) => props.theme.breakpoints.down("sm")} {
      font-size: 14px;
    }
`

type InputControlType = {
    attribute: any,
    itemKey: any,
    unitId: any
}

export default function InputControl({ attribute, itemKey, unitId }: InputControlType) {
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const a11yes: any = useSelector((state: AppStateType) => state.a11yesReducer.a11yes)
    const [a11y, setA11y] = useState<any>({})
    const [value, setValue] = useState('')
    const [textValue, setTextValue] = useState<boolean>(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value)
    }

    useEffect(() => {
        (async function () {
            if(textValue){
              onFetchA11y();
            }
        }())
    }, [textValue]);

    

    const onFetchA11y = async() => {
        await dispatch(fetchA11yes(unitId, user.token))
    }


    const onBlur = () => {
        setTextValue(true);
        const a11yData = {
            item: itemKey,
            attribute: attribute.key,
            accessibility_unit: unitId,
            dynamic_value: value
        }
        if (!a11y.id) {
            dispatch(async (dp: AppDispatchType) => {
                await createA11y(a11yData, user.token)(dp)
            });
        } else if (a11y.id && value.trim()) {
            const a11yIndex = a11yes.findIndex((item: any) => item.attribute === a11y.attribute)
            dispatch(async (dp: AppDispatchType) => {
                await updateA11y(a11yIndex, a11y.id, a11yData, user.token)(dp)
            })
        } else if (a11y.id && !value.trim()) {
            const a11yIndex = a11yes.findIndex((item: any) => item.attribute === a11y.attribute)
            dispatch(async (dp: AppDispatchType) => {
                await deleteA11y(a11y.id, user.token, a11yIndex)(dp)
                setA11y({})
            });
        }
        setTextValue(false);
    }
    useEffect(() => {
        const isPresent = a11yes.find((a11y: any) => (
          a11y.attribute === attribute.key && a11y.item === itemKey
        ))
        if (isPresent) {
            setValue(isPresent.dynamic_value)
            setA11y(isPresent)
        }
        else {
            setValue('')
        }
        return () => {
            setA11y({})
            setValue('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [a11yes])
    return (<>
        {checkDependsCondition(a11yes, attribute.depends_on) ?
            <Box mt={3}>
                <Card>
                    <CardContent>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h6">
                                {attribute.is_mandatory === true ? (
                                    <GradientWrapper >
                                        <GradientText>
                                            {t("CLP_UnitMandatoryLabel")}
                                        </GradientText>
                                    </GradientWrapper>
                                ) : null}
                                <QTitle>{attribute.q_title}</QTitle>
                            </Typography>
                            <input
                                style={{
                                    color: "white",
                                    background: "#1B2635",
                                    border: "0.630435px solid #1C2939",
                                    borderRadius: "5px",
                                    maxWidth: "76px",
                                    marginLeft: "12px"
                                }}
                                value={value}
                                onChange={handleChange}
                                onBlur={onBlur}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            : null
        }
    </>

    )
}